/* 🤖 this file was generated by svg-to-ts */
export const mgcIconHoeFilled: {
  name: 'hoe-filled';
  data: string;
} = {
  name: 'hoe-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.02 3.245c-1.036.09-2.129.663-2.805 1.471-.82.98-1.145 2.203-.93 3.504.067.409 1.662 5.15 1.793 5.331.245.339.795.469 1.202.286.134-.06.556-.456 1.65-1.548l1.47-1.468 4.69 4.687 4.69 4.686.236.068c.492.14.957-.063 1.195-.521.118-.228.115-.619-.008-.861-.065-.129-1.411-1.501-4.736-4.83L10.821 9.4l1.467-1.47c1.601-1.603 1.63-1.64 1.631-2.067.001-.301-.105-.528-.345-.74-.168-.148-.339-.211-2.647-.977-2.801-.93-3.012-.979-3.907-.901"/></svg>`
};
